var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconConnect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 39.999,
    viewBox: "0 0 40 39.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #c8c8c8;\n      }\n\n      .cls-3 {\n        opacity: 0.1;\n      }\n\n      .cls-4 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-5 {\n        fill: #040000;\n      }\n\n      .cls-6 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_2300",
    "data-name": "\\u77E9\\u5F62 2300",
    className: "cls-1",
    width: 20.604,
    height: 19.308
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_43236",
    "data-name": "\\u7EC4 43236",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35594",
    "data-name": "\\u8DEF\\u5F84 35594",
    className: "cls-2",
    d: "M49.2,26.544a20,20,0,1,1-20-20,20,20,0,0,1,20,20",
    transform: "translate(-9.205 -6.544)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_43235",
    "data-name": "\\u7EC4 43235",
    className: "cls-3",
    transform: "translate(9.618 11.011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_43234",
    "data-name": "\\u7EC4 43234"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_43233",
    "data-name": "\\u7EC4 43233",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35611",
    "data-name": "\\u8DEF\\u5F84 35611",
    className: "cls-5",
    d: "M33.7,30.773a3.493,3.493,0,0,1,0-4.935l3.492-3.491a3.489,3.489,0,1,1,4.935,4.935l-2.6,2.6a.776.776,0,1,1-1.1-1.1l2.6-2.6a1.937,1.937,0,1,0-2.739-2.739L34.8,26.935a1.94,1.94,0,0,0,0,2.74.776.776,0,0,1-1.1,1.1",
    transform: "translate(-25.56 -21.326)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35612",
    "data-name": "\\u8DEF\\u5F84 35612",
    className: "cls-5",
    d: "M35.983,35.979a3.493,3.493,0,0,1,0,4.935l-3.492,3.491a3.489,3.489,0,1,1-4.935-4.935l2.6-2.6a.776.776,0,1,1,1.1,1.1l-2.6,2.6a1.937,1.937,0,1,0,2.739,2.739l3.492-3.491a1.94,1.94,0,0,0,0-2.74.776.776,0,0,1,1.1-1.1",
    transform: "translate(-23.519 -26.119)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35613",
    "data-name": "\\u8DEF\\u5F84 35613",
    className: "cls-5",
    d: "M22.7,36.79a.823.823,0,0,1,.144-1.633h2.624a.822.822,0,0,1,0,1.645H22.84a.786.786,0,0,1-.144-.012",
    transform: "translate(-22.018 -25.921)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35614",
    "data-name": "\\u8DEF\\u5F84 35614",
    className: "cls-5",
    d: "M47.159,35.578a.823.823,0,0,1,.144-1.633h2.624a.822.822,0,0,1,0,1.645H47.3a.786.786,0,0,1-.144-.012",
    transform: "translate(-30.146 -25.518)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35615",
    "data-name": "\\u8DEF\\u5F84 35615",
    className: "cls-5",
    d: "M26.245,31.608a.846.846,0,0,1-.142-.038l-2.463-.905a.823.823,0,0,1,.568-1.545l2.462.905a.823.823,0,0,1-.425,1.583",
    transform: "translate(-22.378 -23.898)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35616",
    "data-name": "\\u8DEF\\u5F84 35616",
    className: "cls-5",
    d: "M48.78,41.216a.839.839,0,0,1-.142-.038l-2.463-.905a.823.823,0,0,1,.568-1.545l2.462.905a.823.823,0,0,1-.426,1.583",
    transform: "translate(-29.865 -27.091)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35617",
    "data-name": "\\u8DEF\\u5F84 35617",
    className: "cls-6",
    d: "M33.7,30.207a3.493,3.493,0,0,1,0-4.935l3.492-3.491a3.489,3.489,0,0,1,4.935,4.935l-2.6,2.6a.776.776,0,1,1-1.1-1.1l2.6-2.6a1.937,1.937,0,1,0-2.739-2.739L34.8,26.369a1.94,1.94,0,0,0,0,2.74.776.776,0,0,1-1.1,1.1",
    transform: "translate(-15.778 -10.545)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35618",
    "data-name": "\\u8DEF\\u5F84 35618",
    className: "cls-6",
    d: "M35.983,35.413a3.493,3.493,0,0,1,0,4.935l-3.492,3.491A3.489,3.489,0,0,1,27.556,38.9l2.6-2.6a.776.776,0,1,1,1.1,1.1l-2.6,2.6a1.937,1.937,0,1,0,2.739,2.739l3.492-3.491a1.94,1.94,0,0,0,0-2.74.776.776,0,0,1,1.1-1.1",
    transform: "translate(-14.057 -14.606)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35619",
    "data-name": "\\u8DEF\\u5F84 35619",
    className: "cls-6",
    d: "M22.7,36.223a.823.823,0,0,1,.144-1.633h2.624a.822.822,0,0,1,0,1.645H22.84a.786.786,0,0,1-.144-.012",
    transform: "translate(-12.916 -14.754)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35620",
    "data-name": "\\u8DEF\\u5F84 35620",
    className: "cls-6",
    d: "M47.159,35.011a.823.823,0,0,1,.144-1.633h2.624a.822.822,0,0,1,0,1.645H47.3a.786.786,0,0,1-.144-.012",
    transform: "translate(-20.002 -14.399)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35621",
    "data-name": "\\u8DEF\\u5F84 35621",
    className: "cls-6",
    d: "M26.245,31.041A.846.846,0,0,1,26.1,31L23.64,30.1a.823.823,0,0,1,.568-1.545l2.462.905a.823.823,0,0,1-.425,1.583",
    transform: "translate(-13.233 -12.949)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35622",
    "data-name": "\\u8DEF\\u5F84 35622",
    className: "cls-6",
    d: "M48.78,40.649a.839.839,0,0,1-.142-.038l-2.463-.905a.823.823,0,0,1,.568-1.545l2.462.905a.823.823,0,0,1-.426,1.583",
    transform: "translate(-19.765 -15.752)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConnect);
export default __webpack_public_path__ + "static/media/icon--connect.ab36108ce8b768cd2723e3d4a1962d7a.svg";
export { ForwardRef as ReactComponent };